import {
  AzimuthErrorResponse,
  Maybe,
  Relationship,
  ResourceId,
  ResourceTypes,
  ResourceTypesUnion,
} from '@vendorflow/types'
import { AxiosError } from 'axios'
import { first, isEmpty } from 'lodash'

export function parseCompoundId(compoundId: Maybe<string>): string[] {
  return compoundId ? compoundId.split('--') : []
}

/**
 * @param compoundId potential compound ID
 * @returns the message ID which is the last segment of the compound ID
 */
export function extractMessageIdFromCompoundId(compoundId: Maybe<string>): Maybe<string> {
  const parsed = parseCompoundId(compoundId)
  return parsed.length ? parsed.pop() : null
}

/**
 *
 * @param message the message ID, it may be a compound ID already
 * @param channel the channel ID
 * @returns a compound message ID
 */
export function getCompoundMessageId(message: Maybe<string>, channel: Maybe<string>): string | null {
  return message && channel ? (message.includes('--') ? message : `${channel}--${message}`) : null
}

export function extractErrorMessage(error: AxiosError<AzimuthErrorResponse>): {
  message: string
  statusCode: number | null
} {
  const azError = first(error.response?.data?.errors)
  const message = (error.toJSON() as Error).message

  return {
    message: azError ? azError.title || azError.detail : message,
    statusCode: error.response?.status || null,
  }
}

export function getRelationship<T extends ResourceTypes>(rel: Maybe<Relationship<T>>) {
  const data = rel && !isEmpty(rel) ? (Array.isArray(rel.data) ? rel.data : [rel.data]) : []

  function get() {
    return data
  }

  function getFirst() {
    return data.length ? data[0] : null
  }

  return { get, getFirst }
}

export function toResourceId<T extends ResourceTypesUnion, R extends ResourceId<T>>(resource: R): ResourceId<T> {
  return { id: resource.id, type: resource.type }
}
